import { DatePipe, NgFor, NgIf } from '@angular/common';
import { Component, DestroyRef, EventEmitter, inject, Input, Output } from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { LoadingService } from '../../services/loading.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PaginationComponent } from '../../elements/pagination/pagination.component';
import { debounceTime, distinctUntilChanged, Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { HttpServiceService } from '../../services/http-service.service';
import { NgxToastrService } from '../../_services/ngx-toastr/ngx-toastr.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { USER_PERMISSIONS } from '../../app.constants';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-property-bills',
  imports: [NgFor, MatDatepickerModule, MatFormFieldModule, PaginationComponent, NgIf, ReactiveFormsModule, DatePipe],
  templateUrl: './property-bills.component.html',
  styleUrl: './property-bills.component.css',
  providers: [provideNativeDateAdapter()]
})
export class PropertyBillsComponent {
  @Input() bills: any = [];
  @Output() addBillEvent = new EventEmitter();
  @Output() editBillEvent = new EventEmitter();
  @Output() viewBillEvent = new EventEmitter();


  billTypes : any = [
    {
      "id": 13,
      "paramType": "BillType",
      "paramKey": "Rent Bill",
      "paramValue": "Rent Bill"
  },{
        "id": 1,
        "paramType": "BillType",
        "paramKey": "Electricity Bill",
        "paramValue": "Electricity Bill"
    },
    {
        "id": 2,
        "paramType": "BillType",
        "paramKey": "Society Maintenance",
        "paramValue": "Society Maintenance"
    },
    {
        "id": 3,
        "paramType": "BillType",
        "paramKey": "Water Bill",
        "paramValue": "Water Bill"
    },
    {
        "id": 7,
        "paramType": "BillType",
        "paramKey": "Repairs / Maintenance",
        "paramValue": "Repairs / Maintenance"
    },
    {
        "id": 8,
        "paramType": "BillType",
        "paramKey": "Society Bills",
        "paramValue": "Society Bills"
    },
    {
        "id": 9,
        "paramType": "BillType",
        "paramKey": "Brokerage Bills",
        "paramValue": "Brokerage Bills"
    },
    {
        "id": 11,
        "paramType": "BillType",
        "paramKey": "Tax Bills",
        "paramValue": "Tax Bills"
    },
    {
        "id": 12,
        "paramType": "BillType",
        "paramKey": "Other Bills",
        "paramValue": "Other Bills"
    },
    {
        "id": 192,
        "paramType": "BillType",
        "paramKey": "Property Tax",
        "paramValue": "Property Tax"
    },
    {
        "id": 193,
        "paramType": "BillType",
        "paramKey": "Water Tax",
        "paramValue": "Water Tax"
    },
    {
        "id": 194,
        "paramType": "BillType",
        "paramKey": "internet",
        "paramValue": "Internet"
    },
    {
        "id": 216,
        "paramType": "BillType",
        "paramKey": "Tenant Finding Fee",
        "paramValue": "Tenant Finding Fee"
    },
    {
        "id": 217,
        "paramType": "BillType",
        "paramKey": "Property Management Fee",
        "paramValue": "Property Management Fee"
    },
    {
        "id": 218,
        "paramType": "BillType",
        "paramKey": "Commission - Owner/Tenant",
        "paramValue": "Commission - Owner/Tenant"
    },
    {
        "id": 219,
        "paramType": "BillType",
        "paramKey": "PMS Contract Fee",
        "paramValue": "PMS Contract Fee"
    },
    {
        "id": 220,
        "paramType": "BillType",
        "paramKey": "Service Fee",
        "paramValue": "Service Fee"
    },
    {
        "id": 221,
        "paramType": "BillType",
        "paramKey": "Security Deposit",
        "paramValue": "Security Deposit"
    }
];
  page: any = 1;
  offset_limit : number = 20;
  totalRows: number = 3;
  totalPage: any = 0;
  orderData : any = [];
  allData : any = [];
  propertyId : string = '';
  searchForm!: FormGroup;
  private getAllBillsSubscription? :  Subscription;
  private routeSubscription?: Subscription;
  private generateInvoiceSubscription? : Subscription;
  private viewInvoiceSubscription? : Subscription;
  private  deleteBillSubscription? : Subscription;
  disableClear : boolean = false;
  private authService = inject(LocalStorageService);
  pageCount : number = 1;
  defaultBillTypes : any=  [{ key : 1, keyName : "Rent/Security Deposit"}, { key : 2, keyName : "Expenses"},{ key : 3, keyName : "Company Fee"}];
  private loadingService = inject(LoadingService);
  private destroyRef = inject(DestroyRef);
  constructor(private route: ActivatedRoute, private httpService : HttpServiceService, private fb: FormBuilder, private alertService: NgxToastrService){
   this.routeSubscription =  this.route.paramMap.subscribe(params => {
      this.propertyId = params.get('id') ?? "";
    });
    this.searchForm = this.fb.group({
      name: [''],
      status: [null],
      bill_type: [null],
      role_identifier : [null]
    })
  }

  ngOnInit(){
    this.getAllBills();
      this.searchForm.get('name')?.valueChanges
          .pipe(
              debounceTime(500),
              distinctUntilChanged(),
              takeUntilDestroyed(this.destroyRef)
          )
          .subscribe(value => {
              this.handleSearch(value);
          });
  }

  addPropertyBills(){
    this.addBillEvent.emit();
  }

  editBill(billId : string){
    this.editBillEvent.emit(billId)
  }

  viewBill(billId : any){
    this.viewBillEvent.emit(billId);
  }

  clearBills(){
    this.searchForm.reset('', { emitEvent: false });
    this.getAllBills();
    this.disableClear = false;
  }

  handleSearch(value : any, keepPage : string = ''){
    const searchData = this.searchForm.value;
    let query = '';
    for(let key in searchData){
        if(searchData[key]){
           query+=`&${key}=${searchData[key]}`;
        }
    }
    if(!keepPage) this.page = 1;
    if(query || !value) this.getAllBills(query);
    this.disableClear = (value || query) ? true : false;
  }

  getAllBills(query : any = ''){
    this.getAllBillsSubscription = this.httpService.getAllBills(this.propertyId, this.page, this.offset_limit, query).subscribe({
      next : (response) => {
        this.orderData = response['data']?.["bills"];
        this.orderData = this.orderData?.map((bill: any) => ({
          ...bill,
          billTypeName: this.getdefaultBillTypes(bill.bill_type)
        }));
        this.totalRows = this.offset_limit;
        this.allData = this.paginator(this.orderData, this.page, this.totalRows, response["data"]?.total);
        this.totalPage = response.data.total;
        this.pageCount = response.data.pageCount;
      }
    })
  }

  deleteBill(billId : string){
    this.deleteBillSubscription = this.httpService.deleteBill(billId, this.propertyId).subscribe({
      next : (response) => {
        this.page = 1;
        this.getAllBills();
        this.alertService.success(response.message, "toast-top-right");
      }
    })
  }

  generateInvoice(billId : string){
    this.generateInvoiceSubscription = this.httpService.generateInvoice(billId, this.propertyId).subscribe({
      next : (response) => {
        this.alertService.success(response.message, "toast-top-right");
      },
      complete :() => {
        this.showLoader();
      }
    })
  }

  viewInvoice(billId : string){
    this.viewInvoiceSubscription = this.httpService.viewInvoice(billId, this.propertyId).subscribe({
      next : (response) => {
        window.open(response.data["link"], '_blank');
      }
    })
  }

  pageChange(e: any) {    //  Page Change funcation   ---------
    if(this.page == e) return;
    this.page = e;
    this.handleSearch('', "keepPage");
    // this.allData = this.paginator(this.orderData, this.page, this.totalRows);
    // this.totalPage = this.allData.total_pages;
  }

  paginator(items: any, current_page: any, per_page_items: any, total_records : any) {
    let page = current_page || 1,
      per_page = per_page_items || 10,
      offset = (page - 1) * per_page,

      paginatedItems = items,
      total_pages = Math.ceil(items.length / per_page);


    return {
      page: page,
      startPage : offset + 1,
      endPage : page * per_page,
      per_page: per_page,
      pre_page: page - 1 ? page - 1 : null,
      next_page: (total_pages > page) ? page + 1 : null,
      total: total_records,
      total_pages: total_pages,
      data: paginatedItems
    };
  }

  getdefaultBillTypes(key: number){
    let bills = this.defaultBillTypes.find((bill : any) => bill.key == key);
    return bills ? bills.keyName : "";
  }

  regenerateInvoice(billdId : string){
    this.generateInvoiceSubscription = this.httpService.regenerateInvoice(billdId, this.propertyId).subscribe({
      next : (response) => {
        this.alertService.success(response.message, "toast-top-right");
      },
      complete :() => {
        this.showLoader();
      }
    })
  }

  showLoader(){
    this.loadingService.show();
    setTimeout(() => {
      this.loadingService.hide();
      this.page = 1;
      this.getAllBills();
    }, 3000);
  }

  ngOnDestroy(){
    this.getAllBillsSubscription?.unsubscribe();
    this.routeSubscription?.unsubscribe();
    this.generateInvoiceSubscription?.unsubscribe();
    this.viewInvoiceSubscription?.unsubscribe();
  }

  get checkAddBill() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.ADD_BILL);
  }

  get checkEditBill() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.EDIT_BILL);
  }

  get checkViewBill() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.VIEW_BILL);
  }

  get checkViewInvoice() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.VIEW_INVOICE);
  }

  get checkGenerateInvoice() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.GENERATE_INVOICE);
  }

  get checkDeleteBill() {
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.DELETE_BILL);
  }

  get checkRegenerateInvoice(){
    return this.authService.checkPermission(USER_PERMISSIONS.PROPERTIES.REGENERATE_INVOICE);
  }

}
